import * as cn from "./Summary.scss"
import * as React from "react"
import {User} from "./../model/User"
import {SummaryMatrix, yearColumns, SummaryRow, employeeYear, employeeAvg} from "./Final"
import {EMPLOYEE_YEAR, VACANCY_YEARS} from "../Demand/common";

type Props = {
    summary: SummaryMatrix
    user: User
    company: string
}

type RowProps = {
    title: string
    subTitle?: string
    data: SummaryRow
}

const Row = ({data, title, subTitle}: RowProps) => (
    <tr className = {cn.row}><td className = {cn.cell}>{title}</td><td className = {cn.cell}>{subTitle}</td>
        <td className = {cn.cell}>{data[employeeYear] || ""}</td>
        <td className = {cn.cell}>{data[employeeYear] ? (data[employeeAvg] / data[employeeYear]).toFixed(2).replace(".", ",") : ""}</td>
        {yearColumns.map(column => <td {...{key: column}} className = {cn.cell}>{data[column] || ""}</td>)}
    </tr>
)
export class Summary extends React.PureComponent<Props> {
    render() {
        const {summary, company, user} = this.props

        return (
            <div className = {cn.component}>
                <div className = {cn.page}>
                    <br/>
                    <div className = {cn.heading}>
                        <div className = {cn.title}>
                            Данные о трудоустройстве и потребностях
                            <br/>
                            организации Госкорпорации «Росатом» в выпускниках образовательных организаций
                        </div>
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Организация:</div><div className = {cn.value}>{company}</div>
                        </div>
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Дата заполнения:</div>
                            <div className = {cn.value}>
                                {("0" + new Date().getDate()).slice(-2) + "." + ("0"+(new Date().getMonth()+1)).slice(-2) + "." + new Date().getFullYear()}
                            </div>
                        </div>
{/*
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Ответственный:</div><div className = {cn.value}>{user.executor.fullName}</div>
                        </div>
*/}
                    </div>
                    <br/>
                    <br/>
                    <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                        <colgroup>
                            {Array.apply(null, Array(yearColumns.length + 4)).map((value, key) => <col {...{key}} className = {cn.column}/>)}
                        </colgroup>
                        <thead className = {cn.head}>
                        <tr className = {cn.headRow}>
                            <td className = {cn.headCell} rowSpan = {3}>Тип данных</td>
                            <td className = {cn.headCell} rowSpan = {3}>Уровень обра-зования</td>
                            <td className = {cn.headCell} colSpan = {yearColumns.length + 2}>Количество вакансий</td>
                        </tr>
                        <tr className = {cn.headRow}>
                            <td className = {cn.headCell} colSpan = {2}>Факт</td>
                            <td className = {cn.headCell} colSpan = {VACANCY_YEARS.length}>План</td>
                            <td className = {cn.headCell} colSpan = {yearColumns.length - VACANCY_YEARS.length}>Прогноз</td>
                        </tr>
                        <tr className = {cn.headRow}>
                            <td className = {cn.headCell}>{EMPLOYEE_YEAR} принято</td>
                            <td className = {cn.headCell}>ср. балл</td>
                            {yearColumns.map(year => <td className = {cn.headCell} key = {year}>{year}</td>)}
                        </tr>
                        </thead>
                        <tbody>
                        <Row {...{data: summary.demandVo,      title: "Потребность по общему набору", subTitle: "ВО"}}/>
                        <Row {...{data: summary.demandSpo,     title: "Потребность по общему набору", subTitle: "СПО"}}/>
                        <Row {...{data: summary.demandPhD,     title: "Потребность по общему набору", subTitle: "Асп."}}/>
                        <Row {...{data: summary.hiPoVo,        title: "в т.ч. Потребность по набору выпускников с высоким потенциалом (HiPo)", subTitle: "ВО"}}/>
                        <Row {...{data: summary.hiPoPhD,       title: "в т.ч. Потребность по набору выпускников с высоким потенциалом (HiPo)", subTitle: "Асп."}}/>
                        <Row {...{data: summary.demandNuclear, title: "в т.ч. Потребность по набору выпускников ядерных специальностей", subTitle: "ВО"}}/>
                        <Row {...{data: summary.demandNationalProject, title: "в т.ч. потребности в рамках нац. проекта \"Новые атомные и энергетические технологии\"", subTitle: "ВО"}}/>
                        <Row {...{data: summary.demandTotal,   title: "ИТОГО ПОТРЕБНОСТИ"}}/>
                        {/*
                    <Row {...{data: summary.entranceVo,    title: "Контрольные цифры приема в образовательные организации", subTitle: "ВО"}}/>
                    <Row {...{data: summary.entranceSpo,   title: "Контрольные цифры приема в образовательные организации", subTitle: "СПО"}}/>
                    <Row {...{data: summary.entrancePhD,   title: "Контрольные цифры приема в образовательные организации", subTitle: "Асп."}}/>
                    <Row {...{data: summary.entranceTotal, title: "ИТОГО КОНТРОЛЬНЫЕ ЦИФРЫ ПРИЕМА"}}/>
*/}
                        </tbody>
                    </table>
                </div>
                <div className = {cn.page}>
                    <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                        <colgroup>
                            {Array.apply(null, Array(yearColumns.length + 4)).map((value, key) => <col {...{key}} className = {cn.column}/>)}
                        </colgroup>
                        <tfoot>
                        <tr className = {cn.footRow}/>
                        <tr className = {cn.footRow}><td className = {cn.footCell} colSpan = {15}>
                            {"Данные в Приложении № 1 (на ______ стр.) соответствуют данным, внесенным на ресурс: http://monitoring-greenatom.ru"}
                        </td></tr>
                        <tr className = {cn.footRow}/>

                        {[
                            <tr key = {0} className = {cn.footRow}>
                                <td className = {cn.footCell} colSpan = {3}  rowSpan = {3} style={{verticalAlign: 'bottom'}}>{user.production.position}</td>
                                <td className = {cn.footCell} colSpan = {3}  rowSpan = {3}/>
                                <td className = {cn.footCell} colSpan = {9} rowSpan = {3}>{user.production.fullName}</td>
                            </tr>,
                            <tr key = {1} className = {cn.footRow}/>,
                            <tr key = {2} className = {cn.footRow}/>,
                            <tr key = {3} className = {cn.footRow}/>,
                            <tr key = {4} className = {cn.footRow}><td className = {cn.footCell} colSpan = {6}/><td colSpan = {9} className = {cn.sign}>(Подпись)</td></tr>,
                            <tr key = {5} className = {cn.footRow}/>,
                        ]}

                        {[
                            <tr key = {0} className = {cn.footRow}>
                                <td className = {cn.footCell} colSpan = {3}  rowSpan = {3} style={{verticalAlign: 'bottom'}}>{user.chief.position}</td>
                                <td className = {cn.footCell} colSpan = {3}  rowSpan = {3}/>
                                <td className = {cn.footCell} colSpan = {9} rowSpan = {3}>{user.chief.fullName}</td>
                            </tr>,
                            <tr key = {1} className = {cn.footRow}/>,
                            <tr key = {2} className = {cn.footRow}/>,
                            <tr key = {3} className = {cn.footRow}/>,
                            <tr key = {4} className = {cn.footRow}><td className = {cn.footCell} colSpan = {6}/><td colSpan = {9} className = {cn.sign}>(Подпись)</td></tr>,
                            <tr key = {5} className = {cn.footRow}/>,
                        ]}

                        <tr className = {cn.footRow}>
                            <td className = {cn.footCell} colSpan = {3}  rowSpan = {3} style={{verticalAlign: 'bottom'}}>{user.executor.position}</td>
                            <td className = {cn.footCell} colSpan = {3}  rowSpan = {3}/>
                            <td className = {cn.footCell} colSpan = {9} rowSpan = {3}>{user.executor.fullName}</td>
                        </tr>
                        <tr className = {cn.footRow}/>
                        <tr className = {cn.footRow}/>
                        <tr className = {cn.footRow}/>
                        <tr className = {cn.footRow}><td className = {cn.footCell} colSpan = {6}/><td colSpan = {9} className = {cn.sign}>(Подпись)</td></tr>
{/*

                        <tr className = {cn.footRow}><td className = {cn.executor}>Ответственный:</td><td className = {cn.footCell} colSpan = {14}>{user.executor.fullName}</td></tr>
*/}
                        <tr className = {cn.footRow}><td/><td className = {cn.footCell} colSpan = {14}>{(user.executor.contacts !== undefined) ? user.executor.contacts.first() : ""}</td></tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        )
    }
}